if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = [];
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;
      }

      connectedCallback() {
        super.connectedCallback && super.connectedCallback();
        if (this.initialized) return;
        this.initialized = true;
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.content = this.querySelector('.product-media-modal__content');
        this.dialog = this.querySelector('[role="dialog"]');

        this.dialog?.addEventListener('pointerup', (event) => event.stopPropagation());

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.navigate(-1));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.navigate(1));
        }

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigate(-1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigate(1);
          }
        });

        this.content?.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
        this.content?.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initMediaItems();
        this.showActiveMedia();
        this.preloadAllImages();
      }

      initMediaItems() {
        this.content = this.querySelector('.product-media-modal__content');
        this.mediaItems = Array.from(this.content?.querySelectorAll(':scope > [data-media-id]') || []);
        const activeMediaId = this.openedBy?.getAttribute('data-media-id');
        this.currentIndex = this.mediaItems.findIndex(
          (item) => item.getAttribute('data-media-id') === activeMediaId
        );
        if (this.currentIndex === -1) this.currentIndex = 0;
        this.updateNavState();
      }

      navigate(direction) {
        if (this.mediaItems.length === 0) return;

        const nextIndex = (this.currentIndex + direction + this.mediaItems.length) % this.mediaItems.length;
        this.showMediaAtIndex(nextIndex);
      }

      showMediaAtIndex(index) {
        window.pauseAllMedia();
        this.currentIndex = index;
        this.mediaItems.forEach((element) => {
          element.classList.remove('active');
          element.setAttribute('aria-hidden', 'true');
        });

        const activeMedia = this.mediaItems[index];
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.removeAttribute('aria-hidden');

        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent) activeMedia.loadContent(false);
        activeMedia.querySelector('product-model, deferred-media')?.loadContent?.(false);
        this.updateNavState();
      }

      showActiveMedia() {
        this.showMediaAtIndex(this.currentIndex);
      }

      preloadAllImages() {
        this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.removeAttribute('loading');
        });

        this.mediaItems.forEach((item) => {
          const img = item.tagName === 'IMG' ? item : item.querySelector('img');
          if (img && !img.complete) {
            const preload = new Image();
            preload.src = img.currentSrc || img.src;
          }
        });
      }

      updateNavState() {
        const hasMultipleMedia = this.mediaItems.length > 1;
        this.prevButton?.classList.toggle('hidden', !hasMultipleMedia);
        this.nextButton?.classList.toggle('hidden', !hasMultipleMedia);
      }

      onTouchStart(event) {
        this.touchStartX = event.changedTouches[0].clientX;
        this.touchStartY = event.changedTouches[0].clientY;
      }

      onTouchEnd(event) {
        if (!this.touchStartX || this.mediaItems.length < 2) return;

        const touchEndX = event.changedTouches[0].clientX;
        const touchEndY = event.changedTouches[0].clientY;
        const diffX = this.touchStartX - touchEndX;
        const diffY = this.touchStartY - touchEndY;

        this.touchStartX = 0;
        this.touchStartY = 0;

        if (Math.abs(diffX) < 45 || Math.abs(diffX) < Math.abs(diffY)) return;
        this.navigate(diffX > 0 ? 1 : -1);
      }
    }
  );
}
